import { Box, Radio, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomInput from "../../../../../components/CustomInput";
import RulesModal from "../../RulesModal";

import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import useSWRMutation from "swr/mutation";
import {
  individualOwnerSignupFormValidator,
  otpCodeValidator,
  phoneNumberValidator,
} from "../../../../../../formValidators/auth/signup";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import CommentDotInActive from "../../../../../../media/images/icons/commentDotInActive";
import { handleOwnerTypeRegister } from "../../../../../../redux/features/settingSlice";
import { fetcherPost } from "../../../../../../services/fetcher";
import {
  convertToFormData2,
  PreventInputAlpha,
} from "../../../../../../utils/functions";
import CustomButton from "../../../../../components/CustomButton";
import CustomCheckbox from "../../../../../components/CustomCheckbox";
import CustomInputLabel from "../../../../../components/CustomInputLabel";
import OtpInput from "../../OtpInput";

export default function IndividualOwnerSignup() {
  const theme = useTheme();

  const navigate = useNavigate();

  const { ownerTypeRegister } = useAppSelector((state) => state.settings);
  const dispatch = useAppDispatch();

  const [isvalidForm, setIsValidForm] = useState(false);
  const [otpState, setOtpState] = useState<boolean>(false);

  const [rules, setRules] = useState(false);

  const { trigger: registerTrigger, isMutating: registerMutating } =
    useSWRMutation(
      [
        `/Account/OwnerRegister`,
        null,
        {
          "Content-Type": "multipart/form-data",
        },
      ],
      fetcherPost,
      {
        onSuccess: (data) => {
          const { access_token } = data;

          localStorage.setItem("access_token", access_token);

          navigate("/owner/dashboard");
        },
      }
    );

  const { trigger: verifyCodeTrigger, isMutating: verifyCodeMutating } =
    useSWRMutation(
      [`/Account/DriverSignupSendCode`],

      fetcherPost,
      {
        onSuccess: (e) => {
          setOtpState(true);
        },
      }
    );

  const otpCodeFormik = useFormik({
    initialValues: {
      validationCode: "",
    },
    validationSchema: otpCodeValidator,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const verifyCodeFormik = useFormik({
    initialValues: {
      input: "",
    },
    validationSchema: phoneNumberValidator,
    validateOnChange: true,
    onSubmit: (values) => {
      verifyCodeTrigger(values);
    },
  });

  const formik = useFormik({
    initialValues: {
      userName: "",
      foreName: "",
      surName: "",
      validationCode: "",
      rules: false,
      role: "NobatSender",
      reqFile: "0",
    },
    validationSchema: individualOwnerSignupFormValidator,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    onSubmit: (values) => {
      const newValues = {
        ...values,
        phoneNumber: verifyCodeFormik.values.input,
        validationCode: otpCodeFormik.values.validationCode,
      };
      registerTrigger(convertToFormData2(newValues));
    },
  });
  useEffect(() => {
    verifyCodeFormik.validateForm().then((errors) => {
      console.log(errors);

      if (Object.keys(errors).length > 0) {
        // Handle errors before submitting the form
        // console.log("Validation failed with errors:", errors);
        // verifyCodeFormik.setErrors(errors);
        setIsValidForm(false);
      } else {
        // No errors, proceed with form submission
        // verifyCodeFormik.handleSubmit();
        setIsValidForm(true);
      }
    });
  }, [verifyCodeFormik.values]);

  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    switch (event.target.name) {
      case "rules":
        formik.setFieldValue("rules", event.target.checked);
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        // border: "1px solid green",
        backgroundColor: "bgColor.white",
        justifySelf: "center",
        boxShadow: "0px 4px 15px 3px rgba(0,0,0,0.1)",
        paddingX: "10px",
        paddingY: "16px",
        borderRadius: "16px",
        marginX: "auto",
      }}
    >
      <RulesModal open={rules} handleClose={() => setRules(false)} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: "1",
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "16px",
            color: "primary.main",
            textAlign: "center",
          }}
        >
          ثبت‌نام صاحب کالا
        </Typography>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Radio
              size="small"
              onClick={() => dispatch(handleOwnerTypeRegister("individual"))}
              checked={ownerTypeRegister === "individual"}
            />
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              فرد حقیقی هستم
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Radio
              size="small"
              onClick={() => dispatch(handleOwnerTypeRegister("legal-entity"))}
              checked={ownerTypeRegister === "legal-entity"}
            />
            <Typography
              sx={{
                fontSize: "14px",
              }}
            >
              شرکت حقوقی هستم
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            flex: "1",
          }}
        >
          <Box
            sx={{
              mt: "16px",
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"کد ملی صاحب کالا"}
            </CustomInputLabel>

            <CustomInput
              type="numeric"
              errorMessage={formik.touched.userName && formik.errors.userName}
              error={formik.touched.userName && Boolean(formik.errors.userName)}
              handelChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                PreventInputAlpha(e, formik.handleChange)
              }
              handelOnBlur={formik.handleBlur}
              value={formik.values.userName}
              name="userName"
              placHolder="کدملی صاحب کالا را وارد کنید..."
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: "8px",
            }}
          >
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                نام صاحب کالا
              </CustomInputLabel>{" "}
              <CustomInput
                type="text"
                name="foreName"
                handelChange={formik.handleChange}
                handelOnBlur={formik.handleBlur}
                errorMessage={formik.touched.foreName && formik.errors.foreName}
                error={
                  formik.touched.foreName && Boolean(formik.errors.foreName)
                }
                placHolder="نام‌ صاحب کالا"
              />
            </Box>
            <Box
              sx={{
                mt: "16px",
                flex: 1,
              }}
            >
              <CustomInputLabel required htmlFor="outlined-adornment-amount">
                نام خانوادگی صاحب کالا
              </CustomInputLabel>

              <CustomInput
                type="text"
                name="surName"
                handelChange={formik.handleChange}
                handelOnBlur={formik.handleBlur}
                errorMessage={formik.touched.surName && formik.errors.surName}
                error={formik.touched.surName && Boolean(formik.errors.surName)}
                placHolder="نام‌خانوادگی صاحب کالا"
              />
            </Box>
          </Box>
          <Box
            sx={{
              mt: "16px",
              flex: 1,
            }}
          >
            <CustomInputLabel required htmlFor="outlined-adornment-amount">
              {"تلفن همراه صاحب کالا"}
            </CustomInputLabel>

            <CustomInput
              type="tel"
              errorMessage={
                verifyCodeFormik.touched.input && verifyCodeFormik.errors.input
              }
              error={
                verifyCodeFormik.touched.input &&
                Boolean(verifyCodeFormik.errors.input)
              }
              name="input"
              handelChange={verifyCodeFormik.handleChange}
              value={verifyCodeFormik.values.input}
              placHolder="09121234567"
            />
          </Box>
          <CustomCheckbox
            name="rules"
            checked={formik.values.rules}
            handleChange={handleChangeCheckbox}
            errorMessage={formik.touched.rules && formik.errors.rules}
            error={formik.touched.rules && Boolean(formik.errors.rules)}
            label={
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: "600",
                  marginTop: "10px",
                }}
              >
                من تایید می‌کنم که{" "}
                <Link
                  onClick={() => setRules(true)}
                  style={{
                    color: theme.palette.primary.main,
                  }}
                  to={"#"}
                >
                  {"قوانین و مقررات"}
                </Link>{" "}
                را مطالعه کرده‌ام و شرایط بازارگاه کارن ترابر نت را می‌پذیرم.
              </Typography>
            }
          />
          {otpState && (
            <>
              <OtpInput
                name="validationCode"
                value={otpCodeFormik.values.validationCode}
                // handleChange={otpCodeFormik.handleChange}
                handleChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  if (e.target.value.length > 4) return;

                  PreventInputAlpha(e, otpCodeFormik.handleChange);
                }}
                errorMessage={
                  otpCodeFormik.touched.validationCode &&
                  otpCodeFormik.errors.validationCode
                }
                error={
                  otpCodeFormik.touched.validationCode &&
                  Boolean(otpCodeFormik.errors.validationCode)
                }
                sendOtpState={(isFinished) => setOtpState(!isFinished)}
              />
            </>
          )}
          <CustomButton
            disabled={!isvalidForm}
            loading={verifyCodeMutating || registerMutating}
            onClick={async () => {
              if (otpState) {
                const errors = await otpCodeFormik.validateForm();
                if (Object.keys(errors).length > 0) {
                  otpCodeFormik.setErrors(errors);
                  otpCodeFormik.handleSubmit();
                } else {
                  formik.handleSubmit();
                }
              } else {
                const errors = await formik.validateForm();
                if (Object.keys(errors).length > 0) {
                  formik.setErrors(errors);
                  formik.handleSubmit();
                } else {
                  verifyCodeFormik.handleSubmit();
                }
              }
            }}
            textColor={"#fff"}
            // borderColor="textColor.light"
            // type={!isvalidForm ? "outlined" : "contained"}
            flexDirection="row"
            title={
              !otpState
                ? "ارسال رمز یک‌بار مصرف به تلفن"
                : "تایید رمز و ثبت نام"
            }
            justifyContent="center"
            bgColor={isvalidForm ? "secondary.main" : "textColor.light"}
            width="100%"
            fSize="16px"
            fWeight="700"
            px="10px"
            py="10px"
            borderRadius="10px"
            icon1={!otpState && <CommentDotInActive size={20} />}
            mt="16px"
          />
        </Box>
      </Box>
    </Box>
  );
}
